import type { SyntheticEvent } from "react";

export function preventDefault<T extends SyntheticEvent>(f: () => void) {
  return (event: T) => {
    event?.preventDefault();
    f();
  };
}
